import { render, staticRenderFns } from "./OnMount.vue?vue&type=template&id=c7c163ee&"
import script from "./OnMount.vue?vue&type=script&lang=js&"
export * from "./OnMount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports